import React from 'react';
import '../styles/studiesIntroCard.css';

const StudiesIntroCard = ({ img, title, legend, type }) => {
    return (
        <div className='studies-intro-card'>
            <div className='studies-intro-card-img-container'>
                <img src={img} className='studies-intro-card-img' alt='Études' />
                <p className='studies-intro-card-legend'>{legend}</p>
            </div>
            <h2
                className='studies-intro-card-title'
                dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
            {type === 1 && (
                <p className='studies-intro-card-text'>
                    Testolift appeared as nanosized<br /> spherical shapes, without any<br /> aggregation, <span className='color'>demonstrating<br />
                        the stability of the formulation</span> .
                </p>
            )}
            {type === 2 && (
                <p className='studies-intro-card-text'>
                    Testolift is present as nanosized,<br /> spherical shape with smooth surface,<br /> without any aggregation, <br /><span className='color'>demonstrating the stability<br /> of the liposomal formulation.</span>
                </p>
            )}
        </div>
    );
};

export default StudiesIntroCard;